<div class="pdq-labs">
  <div class="tabs">
    @if (tabs?.length > 1) {
      <pdq-tabs-group (onChange)="setTab($event)" variant="underline" leftMargin="none">
        @for (tab of tabs; track tab.id) {
          <pdq-tab [value]="tab.id" [active]="tab.active" [label]="tab.name"></pdq-tab>
        }
      </pdq-tabs-group>
    }
  </div>
  <div id="pdq-labs-container" class="pdq-labs__content">
    @if (loading) {
      <div>
        <app-main-loader-lottie></app-main-loader-lottie>
      </div>
    } @else if (notFoundMsg) {
      <div class="pdq-labs__not_found">
        <span class="pdq-labs__not_found__err_msg">{{ notFoundMsg }}</span>
      </div>
    } @else if (shouldShowNativeAllTests) {
      <!-- Native All Tests Dashboard -->
      <all-tests-dashboard
        [parameters]="currentParameters"
        (navigateToTestResults)="handleNavigateToTestResults($event)">
      </all-tests-dashboard>
    }
  </div>
</div>
